// BOM removed
import React from "react";
import { Helmet } from "react-helmet-async";

import HomeHero from "./HomeHero/HomeHero";
import HomeAbout from "./HomeAbout/HomeAbout";
import HomeStudentLife from "./HomeStudentLife/HomeStudentLife";
import HomeMessage from "./HomeTestimonials/HomeMessage";

function Home() {
  return (
    <>
      <Helmet>
        <title>
          Sucheta Kriplani Teacher Training College (SKTTC), Jodhpur | B.Ed
          College
        </title>

        <meta
          name="description"
          content="Sucheta Kriplani Teacher Training College (SKTTC), Manaklao, Jodhpur is a private NCTE-approved B.Ed college affiliated with Jai Narain Vyas University (JNVU). Established in 2008, SKTTC offers a 2-year B.Ed program with modern facilities and hostel accommodation."
        />

        <meta
          name="keywords"
          content="Sucheta Kriplani Teacher Training College, SKTTC Jodhpur, B.Ed College Jodhpur, PTET Admission, JNVU Affiliated College, NCTE Approved College Rajasthan, Manaklao College"
        />

        <meta
          property="og:title"
          content="Sucheta Kriplani Teacher Training College (SKTTC), Jodhpur"
        />

        <meta
          property="og:description"
          content="Join SKTTC Jodhpur for NCTE-approved B.Ed program with 100 seat intake. Affiliated with JNVU and located in Manaklao, Rajasthan. Admissions through Rajasthan PTET."
        />

        <meta property="og:type" content="website" />

        <meta property="og:url" content="https://suchetabedcollege.org/" />
      </Helmet>

      <div className="home">
        <HomeHero />
        <HomeAbout />
        <HomeStudentLife />
        <HomeMessage />
      </div>
    </>
  );
}

export default Home;
